import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

import {onMounted, reactive, ref, watch} from "vue";
import {editor} from "@/app/editor";
import {IActivityGift} from "@/app/editor/types";
import GiftItemCheckView from "@/app/editor/views/GiftItemCheckView.vue";
import ImagesUploader from "@/app/editor/views/ImagesUploader.vue";
import {Rule} from "ant-design-vue/es/form";
import WxUploaderButton from "@/components/WxUploaderButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GiftPickView',
  props: {
    gift: {}
  },
  emits: ['update:gift'],
  setup(__props: any, { emit: __emit }) {


const emits = __emit
const props = __props
const gf = ref()
const gfRules: Record<string, Rule[]> = {
  name: [{required: true, message: '礼品名称必填'}],
  image_url: [{required: true, message: '礼品图片必传'}],
  front_value: [{validator: (rule, value) => value > 0 ? Promise.resolve() : Promise.reject('礼品价值不正确')}],
}

const info = reactive({
  group: [] as IActivityGift[][],
  tags: [] as string[],
  tabActive: 0,
  gift: null as null | IActivityGift,
  uploadImage: [] as string[]
})

watch(() => info.gift, g => {
  if (info.tabActive == -1 && g != null) {
    g.thumb_url = g.image_url
    gf.value?.validate().then(() => emits('update:gift', g)).catch((e: any) => {
      if (e.errorFields.length > 0) {
        emits('update:gift', null)
      }
    })
  } else emits('update:gift', g)
}, {flush: 'post', deep: true})

watch(() => info.uploadImage, arr => {
  if (info.gift) {
    info.gift.image_url = arr.first() ?? ''
    setTimeout(gf.value.validate, 200)
  }
})

onMounted(() => {
  info.gift = props.gift
  info.tags = [...Array(6).keys()].map(i => `${i * 10}~${(i + 1) * 10}`)
  info.tags.push('70+')
  info.group = [...Array(7).keys()].map(() => ([] as IActivityGift[]))
  editor.activity?.data.gifts.forEach(g => {
    info.group.forEach((i, k) => {
      if (k < info.group.length - 1) {
        if (g.cost_price_range[0] >= k * 10 && g.cost_price_range[0] <= (k + 1) * 10) i.push(g)
        else if (g.cost_price_range[1] >= k * 10 && g.cost_price_range[1] <= (k + 1) * 10) i.push(g)
      } else if (g.cost_price_range[0] > k * 10) i.push(g)
    })
  })
})

const onTabChange = (key: number) => {
  if (key == -1) info.gift = {
    gift_id: '',
    tags: [],
    name: '',
    thumb_url: '',
    image_url: '',
    front_value: 0,
    cost_price_range: [],
    taobao_keyword: '',
    pdd_keyword: ''
  }
  else info.gift = null
}


return (_ctx: any,_cache: any) => {
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createBlock(_component_a_tabs, {
    "active-key": info.tabActive,
    "onUpdate:activeKey": _cache[4] || (_cache[4] = ($event: any) => ((info.tabActive) = $event)),
    onChange: onTabChange
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.group, (group, k) => {
        return (_openBlock(), _createBlock(_component_a_tab_pane, {
          key: k,
          tab: info.tags[k]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_flex, {
              wrap: "wrap",
              gap: "small"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (g) => {
                  return (_openBlock(), _createBlock(GiftItemCheckView, {
                    key: g.gift_id,
                    gift: g,
                    check: _ctx.gift?.gift_id == g.gift_id,
                    onOnPick: ($event: any) => (info.gift = g)
                  }, null, 8, ["gift", "check", "onOnPick"]))
                }), 128))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["tab"]))
      }), 128)),
      (_openBlock(), _createBlock(_component_a_tab_pane, {
        key: -1,
        tab: "自定义"
      }, {
        default: _withCtx(() => [
          (info.gift)
            ? (_openBlock(), _createBlock(_component_a_form, {
                key: 0,
                ref_key: "gf",
                ref: gf,
                model: info.gift,
                rules: gfRules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    name: "name",
                    label: "礼品名称",
                    required: "",
                    "has-feedback": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: info.gift.name,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((info.gift.name) = $event)),
                        "allow-clear": "",
                        "show-count": "",
                        maxlength: 16
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    name: "image_url",
                    label: "礼品图片",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ImagesUploader, {
                        images: info.uploadImage,
                        "onUpdate:images": _cache[1] || (_cache[1] = ($event: any) => ((info.uploadImage) = $event)),
                        max: 1
                      }, null, 8, ["images"]),
                      _createVNode(WxUploaderButton, {
                        onOnUploadImage: _cache[2] || (_cache[2] = i =>info.uploadImage = [i])
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    name: "front_value",
                    label: "礼品价值",
                    required: "",
                    "has-feedback": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_number, {
                        value: info.gift.front_value,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((info.gift.front_value) = $event)),
                        max: 9999
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    ]),
    _: 1
  }, 8, ["active-key"]))
}
}

})